import { FC, Suspense, lazy, useEffect, useState } from 'react';
import useCommandPaletteState from './commandPaletteState';
import useCommandPaletteShortcut from './useCommandPaletteShortcut';

const CommandPaletteContent = lazy(() => import('./CommandPaletteContent'));

const CommandPalette: FC = () => {
  const isOpen = useCommandPaletteState((state) => state.isOpen);
  const setOpen = useCommandPaletteState((state) => state.setOpen);
  const toggle = useCommandPaletteState((state) => state.toggle);
  const [hasOpened, setHasOpened] = useState(false);

  useCommandPaletteShortcut(toggle);

  useEffect(() => {
    if (isOpen) {
      setHasOpened(true);
      return;
    }
    // The underlying Radix dialog can leave `pointer-events: none` on <body>
    // after close; clear it so the page stays interactive.
    document.body.style.pointerEvents = '';
  }, [isOpen]);

  // Defer loading (and mounting) the palette until it is first opened.
  if (!hasOpened) return null;

  return (
    <Suspense fallback={null}>
      <CommandPaletteContent open={isOpen} onOpenChange={setOpen} />
    </Suspense>
  );
};

export default CommandPalette;
